import { MagicCard } from "@apiserver-rest/ponder-data-client-base";
import { formatCardName } from "@ponder-shared/utils/general";

export function getMagicCardRoute(card: MagicCard): string {
    return getMagicCardRoute2(card.name!, card.set.code!, card.setIndex!);
}

export function getMagicCardRoute2(cardName: string, setCode: string, setIndex: string) {
    return `/magic/card/${setCode}/${setIndex}/${formatCardName(cardName)}`;
}